import { Group } from '../Group';

export class ChatGroup extends Group {
  get isChatGroup(): boolean {
    return true;
  }
}
